import React, { useEffect } from "react";
import { atom, useRecoilState } from "recoil";

export const getAppName = atom({
  key: "getAppName",
  default: "CS",
});

const AppNameToggle = ({ showInternalToggle = true }: { showInternalToggle?: boolean }) => {
  const [appName, setAppName] = useRecoilState<any>(getAppName);

  const handleAppNameClick = (name: string | null) => {
    setAppName(name);
  };

  const buttonStyle = {
    cursor: "pointer",
    padding: "12px 24px",
    transition: "color 0.3s, transform 0.3s, box-shadow 0.3s",
    marginLeft: "20px",
    color: "#333",
    fontFamily: "Arial, sans-serif",
    fontSize: "16px",
    border: "none",
    backgroundColor: "transparent",
    position: "relative",
    overflow: "hidden",
    zIndex: 1,
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
  };

  const activeButtonStyle: any = {
    ...buttonStyle,
    color: "#009cde",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const activeUnderlineStyleCS: any = {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "2px",
    backgroundColor: "#009cde",
    transform: appName === "CS" ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s",
    zIndex: -1,
  };
  const activeUnderlineStyleTP: any = {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "2px",
    backgroundColor: "#009cde",
    transform: appName === "TP" ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s",
    zIndex: -1,
  };
  const activeUnderlineStylePerf: any = {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "2px",
    backgroundColor: "#009cde",
    transform: appName === "PERF" ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s",
    zIndex: -1,
  };
  const activeUnderlineStyleIs: any = {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "2px",
    backgroundColor: "#009cde",
    transform: appName === "IS" ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s",
    zIndex: -1,
  };
  const activeUnderlineStyleCommon: any = {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "2px",
    backgroundColor: "#009cde",
    transform: appName === "TP,CS" ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s",
    zIndex: -1,
  };

  const currentUrl = window.location.href;
  const containsSites = currentUrl.includes("/sites");
  const containscheduleFiles = currentUrl.includes("/scheduleFiles");

  // Set flag for showing Common toggle
  const showCommonToggle = containscheduleFiles;

  // Handle app name changes when navigating between pages
  useEffect(() => {
    if (!containscheduleFiles && appName === "TP,CS") {
      // On non-scheduleFiles pages, reset to TP if currently set to Common
      handleAppNameClick("TP");
    }
  }, [currentUrl, containscheduleFiles, appName]);

  // Set initial app name for new sessions - now defaults to "" (Common)
  // Only reset to CS if not on scheduleFiles page
  if (appName === "TP,CS" && !containscheduleFiles) {
    handleAppNameClick("TP");
  }
  return (
    <div>
      {showCommonToggle && (
        <button
          onClick={() => {
            handleAppNameClick("TP,CS");
          }}
          style={appName === "TP,CS" ? activeButtonStyle : buttonStyle}
        >
          Common
          <div style={activeUnderlineStyleCommon}></div>
        </button>
      )}
      <button
        onClick={() => {
          handleAppNameClick("CS");
        }}
        style={appName === "CS" ? activeButtonStyle : buttonStyle}
      >
        CorporateSight
        <div style={activeUnderlineStyleCS}></div>
      </button>
      <button
        onClick={() => {
          handleAppNameClick("TP");
        }}
        style={appName === "TP" ? activeButtonStyle : buttonStyle}
      >
        Tax Portal
        <div style={activeUnderlineStyleTP}></div>
      </button>
      {/* <button
        onClick={() => {
          handleAppNameClick("PERF");
        }}
        style={appName === "PERF" ? activeButtonStyle : buttonStyle}
      >
        Performance
        <div style={activeUnderlineStylePerf}></div>
      </button> */}
      {showInternalToggle && <button
        onClick={() => {
          handleAppNameClick("IS");
        }}
        style={appName === "IS" ? activeButtonStyle : buttonStyle}
      >
        Internal Sites
        <div style={activeUnderlineStyleIs}></div>
      </button>}
    </div>
  );
};

export default AppNameToggle;
